import { $ajax } from '../assets/js/utils';

// img发请求
export const reportByImg = (url) => {
  let img = new Image();
  const key = `report${Math.floor(Math.random() * 2147483648).toString(36)}`;
  window[key] = img;
  img.onload = img.onerror = img.onabort = function() {
    img.onload = img.onerror = img.onabort = null;
    window[key] = null;
    img = null;
  };
  img.src = url;
};

// http request发请求
export const reportByRequest = (url, data) => {
  $ajax({
    type: 'POST',
    url,
    data
  });
};
